import React from 'react';

import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons/faExclamationTriangle';

import Modal from '~/commons/components/Modal.jsx';

const ModalConfirm = ({
  show,
  onReject = () => {},
  onConfirm = () => {},
}) => (
    <Modal
      show={show}
      onHide={onReject}
      centered
    >
      <div className="p-4">
        <h4 className="text-warning">
          <FA icon={faExclamationTriangle} size="lg" />
        </h4>
        <h6 className="mt-3">
          <strong>
            Deleteing this school will delete all of the students &amp; admins under it as well
          </strong>
        </h6>
        <p>
          It may be a good idea to keep closed schools data for statistics needs.
        </p>
        <h2>Are you sure?</h2>
        <div className="form-row mt-4">
          <div className="col">
            <button
              className="btn btn-block btn-dark"
              onClick={onReject}
            >
              Cancel
            </button>
          </div>
          <div className="col">
            <button
              className="btn btn-block btn-warning"
              onClick={onConfirm}
            >
              Confirm
            </button>
          </div>
        </div>
      </div>
    </Modal>
);

export default ModalConfirm;
